import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { SessionSotrageService } from "src/services/session-sotrage.service";
import { CatalogosService } from "src/services/catalogos/catalogos.service";
import { SweetServices } from "src/services/sweet.services";
import { environment } from "src/environments/environment";
import { actividadVulnerable } from "../model/catalogos/actividad-vulnerable.model";
import { AppComponent } from "../app.component";
import { LoadingService } from "../services/loading.service";
import { PerfilBusqueda } from "../model/session/perfil-busqueda.model";

@Component({
  selector: "app-search-profile",
  templateUrl: "./search-profile.component.html",
  styleUrls: ["./search-profile.component.css"],
})
export class SearchProfileComponent implements OnInit {
  perfilBusqueda: PerfilBusqueda = new PerfilBusqueda();
  razones: any[] = [];
  almacenes: any[] = [];
  usuarioData: any;
  razonSeleccionada: number | null = null;
  almacenSeleccionado: number = -1;
  actividadSeleccionada: number | null = null;
  version = environment.production;
  actividades!: actividadVulnerable[];
  private route = inject(ActivatedRoute);
  loadingService = inject(LoadingService);

  constructor(
    private router: Router,
    private sessionStorage: SessionSotrageService,
    private catalogoService: CatalogosService,
    private alerta: SweetServices,
  ) {}

  ngOnInit(): void {
    this.usuarioData = this.sessionStorage.getCurrentSession();
    this.actividades = this.usuarioData.lstActividadVulnerable;
    this.sessionStorage.setActividadVulnerable(0);
    this.sessionStorage.setSujetoObligado(0);
    this.sessionStorage.setAlmacen(0);
  }

  seleccionarRazon(sujetoObligadoId: number) {
    this.loadingService.mostrar();
    this.almacenSeleccionado = null;
    this.almacenes = [];
    this.sessionStorage.setSujetoObligado(sujetoObligadoId);
    this.razonSeleccionada = sujetoObligadoId;
    this.catalogoService
      .buscarAlmacenesPorRazon(
        sujetoObligadoId,
        this.usuarioData.usuarioId,
        this.actividadSeleccionada ?? 0,
      )
      .subscribe(
        (response) => {
          this.loadingService.ocultar();
          if (response == null) {
            this.alerta.AlertaError(
              "Existe un error, si persiste contacte al administrador del Sitio.",
            );
            this.almacenes = [];
          } else if (response.isCorrect === "false") {
            this.alerta.AlertaError(response.message);
            this.almacenes = [];
          } else if (response.data.total === 0) {
            this.alerta.AlertaSinResultados(response.message);
            this.almacenes = [];
          } else {
            this.almacenes = response.data.info.result;
          }
        },
        (err) => {
          this.loadingService.ocultar();
          this.alerta.AlertaCatch(err);
        },
      );
  }

  cargaAlmacenes() {
    const user = this.sessionStorage.getCurrentSession();
    const razon = this.razones.find(
      (r) => r.sujetoObligadoId === this.razonSeleccionada,
    );
    const almacen = this.almacenes.find(
      (a) => a.almacenId === this.almacenSeleccionado,
    );
    const actividad = this.actividades.find(
      (a) => a.actividadVulnerableId === this.actividadSeleccionada,
    );

    user.sujetoObligadoId = this.razonSeleccionada || undefined;
    user.razonSocialNombre = razon?.sujetoObligado || "";
    user.almacenId = this.almacenSeleccionado || undefined;
    user.almacenNombre = almacen?.almacen || null;
    user.actividadVulnerable = actividad?.actividadVulnerable || undefined;
    user.actividadVulnerableId = actividad?.actividadVulnerableId || 0;

    if (user.almacenId === undefined && user.almacenNombre === null) {
      user.almacenes = this.almacenes;
    }

    this.sessionStorage.setCurrentSession(user);
    //Obtenemos el Perfil de Búsqueda Inicio
    this.perfilBusqueda.actividadesVulnerables = this.actividades.map((a) => ({
      actividadVulnerableId: a.actividadVulnerableId,
    }));

    this.perfilBusqueda.actividadVulnerableId = user.actividadVulnerableId;
    this.perfilBusqueda.claveActividadVulnerable = actividad?.claveActividad
      ? actividad.claveActividad
      : "";
    this.perfilBusqueda.sujetoObligadoId = user.sujetoObligadoId
      ? user.sujetoObligadoId
      : -1;
    this.perfilBusqueda.claveSujetoObligado = razon?.rfc ? razon?.rfc : "";

    const almacenesFiltrados =
      this.almacenSeleccionado == null
        ? this.almacenes
        : this.almacenes.filter(
            (a) => a.almacenId === this.almacenSeleccionado,
          );

    // Mapeamos para que cada elemento sea un objeto con la propiedad almacenId
    this.perfilBusqueda.almacen = almacenesFiltrados.map((a) => ({
      almacenId: a.almacenId,
    }));

    this.perfilBusqueda.rolId = user.rolId;
    //Obtenemos el Perfil de Búsqueda cierre

    this.sessionStorage.setPerfilBusqueda(this.perfilBusqueda);
    this.router.navigate(["/v2"]);
  }

  regresar() {
    this.catalogoService.limpiarCatalogos(false);
    this.sessionStorage.logout();
  }

  seleccionarActividadV(actividadVulnerableId: number) {
    this.loadingService.mostrar();
    this.razonSeleccionada = null;
    this.razones = [];
    this.sessionStorage.setActividadVulnerable(actividadVulnerableId);
    this.actividadSeleccionada = actividadVulnerableId;
    this.catalogoService.buscarRazonesPorUsuario(this.usuarioData.usuarioId,actividadVulnerableId)
      .subscribe(
        (response) => {
          this.loadingService.ocultar();
          if (response == null) {
            this.alerta.AlertaError(
              "Existe un error, si persiste contacte al administrador del Sitio.",
            );
            this.razones = [];
          } else if (response.isCorrect === "false") {
            if (response.message == "No existen razones para el usuario.") {
              this.alerta.AlertaSinResultados(response.message);
            } else {
              this.alerta.AlertaError(response.message);
            }

            this.razones = [];
          } else if (response.data.total === 0) {
            this.alerta.AlertaSinResultados(response.message);
            this.razones = [];
          } else {
            this.razones = response.data.info.result;
          }
        },
        (err) => {
          this.loadingService.ocultar();
          this.alerta.AlertaCatch(err);
        },
      );
  }

  seleccionarAlmacen(almacenId: number) {
    this.almacenSeleccionado = almacenId;
    this.sessionStorage.setAlmacen(almacenId);
  }
}
